import { ButtonProps } from '@boss/types/b2b-b2c';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

import ButtonOrAnchor from '../_Button';

const ButtonStyles = cva(
  'flex gap-3.75 w-fit h-fit items-center text-sm leading-[150%] px-5 py-2.5 rounded-full transition duration-400 ease',
  {
    variants: {
      type: {
        primary: 'bg-green-soft text-green hover:bg-green hover:text-green-soft',
        secondary:
          'bg-white border-1  border-solid border-green-dark hover:border-green-lush hover:bg-green-lush text-green-dark',
        tertiary: 'text-green-dark underline underline-offset-4 px-0 hover:text-green',
        link: 'text-green-dark text-base underline underline-offset-4 px-0 hover:text-green',
        mobileMenu: '',
        action:
          'bg-red hover:bg-red-light hidden gap-2 rounded-full text-white px-3 text-lg font-bold hover:text-white md:flex',
      },
      disabled: {
        true: 'bg-gray px-5 pointer-events-none text-white no-underline',
      },
    },
  },
);

const SpanStyles = cva('w-full', {
  variants: {
    type: {
      primary: 'font-bold',
      secondary: '',
      tertiary: '',
      link: '',
      mobileMenu: 'font-bold',
      action: 'font-bold text-white',
    },
    disabled: {
      true: '',
    },
  },
});

const Button = ({
  icon = faChevronRight,
  iconPosition,
  type,
  disabled,
  onClick,
  href,
  label,
  alternativeText,
  className,
  radius,
  onKeyDown,
  hideLabel,
  testId,
  submitButton,
  anchorClassName,
  labelClassName,
  fileToDownload,
  trackInfo,
  target,
}: ButtonProps) => (
  <ButtonOrAnchor
    alternativeText={alternativeText}
    anchorClassName={anchorClassName}
    className={twMerge(ButtonStyles({ type, disabled }), className, radius ?? 'rounded-2')}
    disabled={disabled}
    fileToDownload={fileToDownload}
    href={href}
    onClick={onClick}
    onKeyDown={onKeyDown}
    submitButton={submitButton}
    target={target}
    testId={testId}
    trackInfo={trackInfo}
  >
    {icon && (iconPosition === 'left' || iconPosition === 'both') && <FontAwesomeIcon icon={icon} />}
    {!hideLabel && label && <span className={twMerge(SpanStyles({ type, disabled }), labelClassName)}>{label}</span>}
    {icon && (iconPosition === 'right' || iconPosition === 'both') && <FontAwesomeIcon icon={icon} />}
  </ButtonOrAnchor>
);

export default Button;
